export default {
  methods: {
    /**
     * Add a validation error to the Formulate Vue element context.
     * - This will ONLY cause element to be marked as invalid and display errors.
     * - Form submission are NOT blocked, unfortunately.
     *
     * @param errorMessage string
     */
    addValidationError(errorMessage) {
      if (!this.context || typeof this.context.setErrors !== 'function') return;

      this.context.setErrors([...this.context.errors, errorMessage]);
    },
    /**
     * Remove a validation error from the Formulate Vue element context.
     *
     * @param errorMessage string
     */
    removeValidationError(errorMessage) {
      if (!this.context || typeof this.context.setErrors !== 'function') return;

      const filteredErrors = this.context.errors.filter(err => err !== errorMessage);
      this.context.setErrors(filteredErrors);
    }
  },
};